import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Clock, AlertTriangle } from 'lucide-react';
import { getTimezoneDisplayWithOffset } from '@/utils/timezone-detection';

interface TimezoneWarningProps {
  userTimezone: string;
  practitionerTimezone: string;
  className?: string;
}

export const TimezoneWarning: React.FC<TimezoneWarningProps> = ({
  userTimezone,
  practitionerTimezone,
  className = ""
}) => {
  // Don't show warning if timezones are the same
  if (userTimezone === practitionerTimezone) {
    return null;
  }

  const userDisplay = getTimezoneDisplayWithOffset(userTimezone);
  const practitionerDisplay = getTimezoneDisplayWithOffset(practitionerTimezone);

  return (
    <Alert className={`border-amber-200 bg-amber-50 ${className}`}>
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="text-amber-800">
        <div className="flex items-start gap-2">
          <Clock className="h-4 w-4 mt-0.5 flex-shrink-0" />
          <div className="space-y-1">
            <p className="font-medium">Different time zones detected</p>
            <div className="text-sm space-y-1">
              <div>Your timezone: <span className="font-medium">{userDisplay}</span></div>
              <div>Practitioner timezone: <span className="font-medium">{practitionerDisplay}</span></div>
            </div>
            <p className="text-xs mt-2">
              Times shown are in the your timezone. Please double-check your appointment time to avoid confusion.
            </p>
          </div>
        </div>
      </AlertDescription>
    </Alert>
  );
};